import StringFormat from "../../utils/stringFormat.js";

// --------------------------------------------
// --          iATS 3DS Payer Data           --
// --------------------------------------------

export default class Iats3dsPayerData {
    static card;
    static data;
    static address;
    static creditCardNumber;
    static creditCardExpiry;
    static total;
    static firstName;
    static lastName;
    static addressLine1;
    static city;
    static countrySubEntity;
    static zipCode;
    static country;
    static formatter;

    constructor(card, data) {
        this.formatter = new StringFormat();
        this.card = card;
        this.data = data;
        this.creditCardNumber = this.getCreditCardNumber();
        this.creditCardExpiry = this.getCreditCardExpiration();
        this.total = this.data.Amount;
        this.firstName = this.getFirstName();
        this.lastName = this.getLastName();
        this.address = this.getAddress(this.data.Address);
        this.addressLine1 = this.getAddressLine(this.address);
        this.city = this.formatter.getSafeValue(this.address.CityName);
        this.countrySubEntity = this.formatter.getSafeValue(this.address.CountrySubEntityCode);
        this.zipCode = this.formatter.getSafeValue(this.address.PostalCode);
        this.country = this.formatter.getSafeValue(this.address.CountryCode);
    }

    validate() {
        if (this.formatter.isNullOrUndefined(this.data.Address)) {
            return "Billing address is required.";
        }
        if (this.formatter.isNullOrUndefined(this.data.Address.CountryCode)) {
            return "Billing address must contain a country.";
        }
        return null;
    }

    // Formatted first name.
    getFirstName() {
        const firstName = this.formatter.removeAllDigits(this.data.Name.FirstName); 
        return firstName === "" ? null : firstName;
    }

    // Formatted last name.
    getLastName() {
        return this.formatter.removeAllDigits(this.data.Name.LastName);
    }

    // Formatted credit card number.
    getCreditCardNumber() {
        return this.formatter.removeAllNonDigits(this.card.number.value);
    }

    // Formatted expiration date.
    getCreditCardExpiration() {
        return this.card.expiration.value.replace("/", new Date().getFullYear().toString().slice(0, 2));
    }

    // Returns user selected billing address.
    getAddress(a) {
        if (a !== undefined && a !== null) {
            return a;
        }
        return {
            AddressLines: [null],
            CityName: null,
            CountryCode: null,
            CountryName: null,
            CountrySubEntityCode: null,
            CountrySubEntityName: null,
            PostalCode: null
        };
    }

    // Returns the first billing address line if it exists, else null.
    getAddressLine(a) {
        if (a === undefined || a === null) return null;
        if (a.AddressLines === undefined || a.AddressLines === null) return null;
        if (!a.AddressLines.length) return null;
        return this.formatter.sanitizeAddressLine(a.AddressLines[0]);
    }

    // Returns true if formatted postal codes match.
    postalCodesMatch() {
        // Postal code is unset/null if it's hidden. If so, we don't need to match it.
        if (this.card.postal === undefined || this.card.postal === null) return true;

        const cardPostal = this.formatter.getPostalCodeBase(this.formatter.removeWhitespace(this.card.postal.value));
        const addressPostal = this.formatter.getPostalCodeBase(this.formatter.removeWhitespace(this.address.PostalCode));
        // We're better off using toLowerCase() here
        // than localeCompare (not supported by IE10 or Opera) 
        // or a regular expression.
        return cardPostal.toLowerCase() === addressPostal.toLowerCase();
    }
}